/* eslint-disable react-hooks/exhaustive-deps */
import { Link } from "react-router-dom";
import React, { useEffect, useMemo, useState } from "react";
import { useDoSeeDataContext } from "../../../context/doSeeData/DoSeeDataContext";
import { pushOneCinema } from "../../../middlewares/sysNavigation/SysNavigation";
import { BreadCrumbComponent } from "../../../middlewares/breadCrumb/BreadCrumbComponent";
import {
  Modal,
  GoBack,
  MySearch,
  MyButton,
  Pagination,
  DashboardIntro,
} from "../../home/component/Component";
import { _TYPES_ } from "../utils/types";
import { _PAGE_SIZE_ } from "../../../middlewares/other/tools";
import { useGeoPositionContext } from "../utils/geoPosition";
import { useAdminContext } from "../../../context/admin/context/AdminContext";
import PromoteContent from "../utils/PromoteContent";
import { FaRegCheckSquare, FaRegSquare, FaRegTrashAlt } from "react-icons/fa";
import { RiRefreshLine } from "react-icons/ri";

const addRoute = "/data/cinema/add";
const editRoute = "/data/cinema/edit";
const doseeDataRoutes = "/dosee/data";

const Overview = () => {
  const [cinemasList, setCinemasList] = useState([]);
  const { cinema, cinemaCount, fetchDoSeeData, deleteOneContent } =
    useDoSeeDataContext();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);
  const [localSearch, setLocalSearch] = useState([]);

  const [loading, setLoading] = useState(false);
  const [selectedContentIds, setSelectedContentIds] = useState([]);
  const [showBulkDelete, setShowBulkDelete] = useState(false);

  const {
    country_id,
    entry_label,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const data_request_body = {
    country_id,
    first_level_id,
    second_level_id,
    third_level_id,
    fourth_level_id,
    content: _TYPES_.CINEMA,
  };

  useEffect(() => {
    if (!cinema) fetchDoSeeData(data_request_body, page, pageSize);
    setCinemasList(cinema);
  }, [cinema]);

  const reloadData = () => fetchDoSeeData(data_request_body, page, pageSize);

  const SearchList = (e) => {
    const key = e.target.value.toString().toLowerCase();
    const searchArray = [];
    cinema?.forEach((c) => {
      if (c?.title?.toString().toLowerCase().includes(key)) searchArray.push(c);
    });
    setCinemasList(key ? searchArray : cinema);
  };

  const LocalData = localSearch?.length > 0 ? localSearch : cinemasList;

  const pageIds = useMemo(
    () => (LocalData ? LocalData.map((c) => c?.cinema_id) : []),
    [LocalData]
  );
  const isAllSelected =
    pageIds.length > 0 &&
    pageIds.every((id) => selectedContentIds.includes(id));

  const toggleSelectAll = () => {
    if (isAllSelected) {
      const remaining = selectedContentIds.filter((id) => !pageIds.includes(id));
      setSelectedContentIds(remaining);
    } else {
      const merged = new Set([...selectedContentIds, ...pageIds]);
      setSelectedContentIds(Array.from(merged));
    }
  };

  const deleteMany = async () => {
    setLoading(true);
    for (let i = 0; i < selectedContentIds.length; i++) {
      await deleteOneContent({
        data_id: selectedContentIds[i],
        content: _TYPES_.CINEMA,
      });
    }
    setLoading(false);
    setShowBulkDelete(false);
    setSelectedContentIds([]);
    reloadData();
  };

  const container = "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8";
  const btnBase =
    "inline-flex items-center gap-2 px-3.5 py-2.5 rounded-lg border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-60 disabled:cursor-not-allowed";
  const btnPrimary =
    "bg-blue-600 text-white border-blue-600 hover:bg-blue-500 focus-visible:ring-blue-500";
  const btnNeutral =
    "bg-white text-slate-700 border-slate-200 hover:bg-slate-50";
  const btnDanger =
    "bg-red-600 text-white border-red-600 hover:bg-red-500 focus-visible:ring-red-500";
  const card =
    "overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm";

  return (
    <div className="h-full overflow-y-auto bg-white">
      <div className={`${container} py-4 lg:py-6`}>
        <div className="mb-4">
          <BreadCrumbComponent />
        </div>

        <div className="flex items-center justify-between mb-2">
          <GoBack props={{ route: doseeDataRoutes }} />
        </div>

        <div className="mb-6">
          <DashboardIntro props={{ intro: `Cinema`, name: entry_label }} />
        </div>

        <div className="flex flex-col gap-4">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
            <MySearch
              type={_TYPES_.CINEMA}
              value={localSearch}
              showGlobalSearch={true}
              setValue={setLocalSearch}
              onChange={SearchList}
            />

            {country_id ? (
              <Link to={addRoute} className="shrink-0">
                <MyButton title="Add Cinema" className={`${btnBase} ${btnPrimary}`} />
              </Link>
            ) : null}
          </div>

          <div className="flex items-center gap-3">
            <MyButton onClick={toggleSelectAll} className={`${btnBase} ${btnNeutral}`}>
              {isAllSelected ? (
                <FaRegCheckSquare className="text-green-600 text-lg" />
              ) : (
                <FaRegSquare className="text-slate-700 text-lg" />
              )}
              <span className="text-slate-700">
                {isAllSelected ? "Unselect All" : "Select All"}
              </span>
            </MyButton>

            <MyButton
              onClick={() =>
                selectedContentIds?.length > 0 && setShowBulkDelete(true)
              }
              className={`${btnBase} ${selectedContentIds?.length > 0 ? btnDanger : btnNeutral
                }`}
              disabled={selectedContentIds?.length === 0 || loading}
            >
              {loading ? (
                <RiRefreshLine className="text-lg animate-spin" />
              ) : (
                <FaRegTrashAlt className="text-base" />
              )}
              <span>
                Delete{" "}
                {selectedContentIds?.length > 0 ? selectedContentIds.length : ""}{" "}
                {selectedContentIds?.length === 1 ? "Item" : "Items"}
              </span>
            </MyButton>
          </div>

          <div className={card}>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-slate-50 text-slate-600">
                  <tr>
                    <th className="px-4 py-3 text-left font-semibold">Select</th>
                    <th className="px-4 py-3 text-left font-semibold">Title</th>
                    <th className="px-4 py-3 text-left font-semibold">Open Days</th>
                    <th className="px-4 py-3 text-center font-semibold">Action</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-200">
                  {(LocalData || [])?.length > 0 ? (
                    LocalData?.map((cin, key) => {
                      const isSelected = selectedContentIds.includes(cin?.cinema_id);
                      return (
                        <tr key={key} className="hover:bg-slate-50 transition-colors">
                          <td className="px-4 py-3">
                            <MyButton
                              className={`${btnBase} ${btnNeutral}`}
                              onClick={() => {
                                if (isSelected) {
                                  setSelectedContentIds((prev) =>
                                    prev.filter((id) => id !== cin?.cinema_id)
                                  );
                                } else {
                                  setSelectedContentIds((prev) => [
                                    ...prev,
                                    cin?.cinema_id,
                                  ]);
                                }
                              }}
                            >
                              {isSelected ? (
                                <FaRegCheckSquare className="text-green-600 text-lg" />
                              ) : (
                                <FaRegSquare className="text-slate-700 text-lg" />
                              )}
                            </MyButton>
                          </td>
                          <td className="px-4 py-3">{cin?.title}</td>
                          <td className="px-4 py-3">{cin?.open_days}</td>
                          <td className="px-2 py-3">
                            <ActionButton props={cin} reloadData={reloadData} />
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr className="animate-pulse">
                      <td className="px-4 py-3">...</td>
                      <td className="px-4 py-3">...</td>
                      <td className="px-4 py-3">...</td>
                      <td className="px-4 py-3">...</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <Pagination
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            total_items={cinemaCount}
            callbackFunction={(p, size) => {
              fetchDoSeeData(data_request_body, p, size);
            }}
          />
        </div>

        <div className="relative z-[9999]">
          <Modal
            props={{
              name: `Delete ${selectedContentIds?.length} ${selectedContentIds?.length === 1 ? "Item" : "Items"
                }`,
              showModal: showBulkDelete,
              setShowModal: () => setShowBulkDelete(false),
              delete: deleteMany,
            }}
          />
        </div>
      </div>
    </div>
  );
};

const ActionButton = ({ props, reloadData }) => {
  const { sysAdmin } = useAdminContext();
  const isSuperAdmin = ["super_admin", "admin"].includes(sysAdmin?.role);
  const { cinema, deleteOneContent, updateOneContent } = useDoSeeDataContext();

  const [showModal, setShowModal] = useState(false);
  const [confirmSuspend, setConfirmSuspend] = useState(false);

  const [promote, setPromote] = useState(false);
  const [promoteLoader, setPromoteLoader] = useState(false);

  const cinema_id = props?.cinema_id;
  const cinema_title = props?.title;
  const item = props;

  const deleteOneCinemaById = async (cinema_id) => {
    const { status } = await deleteOneContent({
      data_id: cinema_id,
      content: _TYPES_.CINEMA,
    });
    setShowModal(false);
    if (status === 200) {
      reloadData();
    }
  };

  const buildData = (object, position) => {
    return {
      country_id: object?.country_id,
      created_by: object?.created_by,
      description: object?.description,
      first_level_id: object?.first_level_id,
      fourth_level_id: object?.fourth_level_id,
      second_level_id: object?.second_level_id,
      slug: object?.slug,
      status: object?.status,
      third_level_id: object?.third_level_id,
      thumbnail: object?.thumbnail,
      title: object?.title,
      url_images: object?.url_images,
      promoted: `${position}`,
    };
  };

  const promotion = async (position) => {
    const previousPromoted = cinema?.find(
      (c) => c?.promoted === String(position)
    );
    setPromoteLoader(true);
    const { status } = await updateOneContent({
      data_id: item?.cinema_id,
      data: buildData(props, position),
      content: _TYPES_.CINEMA,
    });
    if (previousPromoted) {
      await updateOneContent({
        data_id: previousPromoted?.cinema_id,
        data: buildData(previousPromoted, "no"),
        content: _TYPES_.CINEMA,
      });
    }
    setPromoteLoader(false);
    setPromote(false);
    if (status === 200) {
      reloadData();
    }
  };

  const suspension = async (cin) => {
    const data = {
      country_id: cin?.country_id,
      created_by: cin?.created_by,
      description: cin?.description,
      first_level_id: cin?.first_level_id,
      fourth_level_id: cin?.fourth_level_id,
      second_level_id: cin?.second_level_id,
      slug: cin?.slug,
      status: cin?.status === 1 ? 0 : 1,
      third_level_id: cin?.third_level_id,
      thumbnail: cin?.thumbnail,
      title: cin?.title,
      url_images: cin?.url_images,
    };
    const { status } = await updateOneContent({
      data_id: cin?.cinema_id,
      data: data,
      content: _TYPES_.CINEMA,
    });
    setConfirmSuspend(false);
    if (status === 200) {
      reloadData();
    }
  };

  const btnBase =
    "inline-flex items-center gap-2 px-3.5 py-2.5 rounded-lg border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-60 disabled:cursor-not-allowed";
  const btnPrimary =
    "bg-blue-600 text-white border-blue-600 hover:bg-blue-500 focus-visible:ring-blue-500";
  const btnInfo =
    "bg-blue-700 text-white border-blue-700 hover:bg-blue-600 focus-visible:ring-blue-600";
  const btnNeutral =
    "bg-white text-slate-700 border-slate-200 hover:bg-slate-50";
  const btnDanger =
    "bg-red-600 text-white border-red-600 hover:bg-red-500 focus-visible:ring-red-500";
  const btnWarn =
    "bg-amber-600 text-white border-amber-600 hover:bg-amber-500 focus-visible:ring-amber-500";

  return (
    <>
      <div className="relative z-[9999]">
        <Modal
          props={{
            name: cinema_title,
            showModal: showModal,
            setShowModal: () => setShowModal(false),
            delete: () => deleteOneCinemaById(cinema_id),
          }}
        />
      </div>

      <ConfirmDialog
        open={confirmSuspend}
        title={item?.status === 1 ? "Suspend this cinema?" : "Unsuspend this cinema?"}
        description={
          item?.status === 1
            ? "This will hide the cinema from public listings until re-enabled."
            : "This will make the cinema visible to the public again."
        }
        confirmText={item?.status === 1 ? "Suspend" : "Unsuspend"}
        cancelText="Cancel"
        onClose={() => setConfirmSuspend(false)}
        onConfirm={() => suspension(item)}
        variant={item?.status === 1 ? "neutral" : "warn"}
      />

      <div className="relative z-[9999]">
        <PromoteContent
          visible={promote}
          setVisible={setPromote}
          loading={promoteLoader}
          ids={cinema
            ?.filter(
              (c) => !["yes", "no", null, undefined].includes(c?.promoted)
            )
            .map((c) => ({
              id: c?.cinema_id,
              title: c?.title,
              position: parseInt(c?.promoted),
            }))}
          onClick={(position) => promotion(position)}
        />
      </div>

      <div className="flex flex-row justify-end items-center px-2 py-2 gap-2">
        {isSuperAdmin ? (
          <>
            <MyButton
              title={item?.status === 1 ? "Suspend" : "Unsuspend"}
              className={`${btnBase} ${item?.status === 1 ? btnPrimary : btnWarn}`}
              onClick={() => setConfirmSuspend(true)}
            />
            <MyButton
              title={
                ["yes", "no", null, undefined].includes(item?.promoted)
                  ? "Promote"
                  : "Unpromote"
              }
              className={`${btnBase} ${["yes", "no", null, undefined].includes(item?.promoted)
                ? btnPrimary
                : btnWarn
                }`}
              onClick={() => setPromote(true)}
            />
          </>
        ) : null}

        <Link to={editRoute}>
          <MyButton
            title="Edit"
            className={`${btnBase} ${btnInfo}`}
            onClick={() => pushOneCinema(item)}
          />
        </Link>
        <MyButton
          title="Delete"
          className={`${btnBase} ${btnDanger}`}
          onClick={() => setShowModal(true)}
        />
      </div>
    </>
  );
};

const ConfirmDialog = ({
  open,
  title,
  description,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onClose,
  onConfirm,
  variant = "neutral",
}) => {
  if (!open) return null;

  const btnBase =
    "inline-flex items-center justify-center gap-2 px-3.5 py-2.5 rounded-lg border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2";
  const btnNeutral =
    "bg-white text-slate-700 border-slate-200 hover:bg-slate-50";
  const btnWarn =
    "bg-amber-600 text-white border-amber-600 hover:bg-amber-500 focus-visible:ring-amber-500";

  return (
    <div className="fixed inset-0 z-[9999]">
      <div className="absolute inset-0 bg-black/30" onClick={onClose} />
      <div className="absolute inset-0 flex items-center justify-center p-4">
        <div className="w-full max-w-md rounded-xl border border-slate-200 bg-white shadow-xl">
          <div className="p-5">
            <h3 className="text-base font-semibold text-slate-900">{title}</h3>
            {description ? (
              <p className="mt-2 text-sm text-slate-600">{description}</p>
            ) : null}
            <div className="mt-5 flex items-center justify-end gap-2">
              <button type="button" className={`${btnBase} ${btnNeutral}`} onClick={onClose}>
                {cancelText}
              </button>
              <button
                type="button"
                className={`${btnBase} ${variant === "warn" ? btnWarn : btnNeutral}`}
                onClick={onConfirm}
              >
                {confirmText}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Overview;
